module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_badge_bronze-47f0378dc6bb9b7c777049625364dd09.svg";